export const SOCIAL_ORDER_FOCUS_OPTIONS: { label: string; value: string }[] = [
  { label: 'Социальная', value: 'социальная' },
  { label: 'Образование', value: 'образование' },
  { label: 'Экология', value: 'экология' },
  { label: 'Наука', value: 'наука' },
  { label: 'Культура', value: 'культура' },
  { label: 'Инфраструктура', value: 'инфраструктура' },
  { label: 'Городская среда', value: 'городская среда' },
  { label: 'Здоровье и физкультура', value: 'здоровье и физкультура' },
  { label: 'Производство', value: 'производство' },
  { label: 'Цифровая экономика', value: 'цифровая экономика' },
  { label: 'Семья', value: 'семья' },
]

export const SOCIAL_ORDER_FOCUS_VALUES = SOCIAL_ORDER_FOCUS_OPTIONS.map((o) => o.value) as [string, ...string[]]
